import React from 'react';

import {
  Container,
  Stack,
} from '@mui/material'
import { StyledButton, SubHeaderText } from '../common/_components'
import { useAuth } from '../../hooks/useAuth';
import { useParams } from 'react-router-dom';
import { getIsMobileApp } from '../../utils/mobileApp';

interface SubscribeProps {
  toolName: string | React.ReactNode
}
const Subscribe = (props: SubscribeProps) => {
  const { toolName = 'Stokastic Tools' } = props;
  const { login, isAuthenticated } = useAuth();
  const { league } = useParams<{ league: string }>();
  const isMobileApp = getIsMobileApp();

  return (
    <Container>
      <Stack direction='column' alignItems='center' justifyContent='center' rowGap='20px' height={'calc(100vh - 124px)'} >
        <SubHeaderText>
          {isMobileApp ? (
            <>You don't have access to {league} <span style={{ whiteSpace: 'nowrap' }}>{toolName}</span>.</>
          ) : isAuthenticated ? (
            <>You don't have access to {league} <span style={{ whiteSpace: 'nowrap' }}>{toolName}</span>. Switch sports or upgrade your subscription.</>
          ) : (
            <>Subscribe to a <span style={{ whiteSpace: 'nowrap' }}>{toolName}</span> supported package to access</>
          )}
        </SubHeaderText>
        {!isMobileApp && (
          <Stack
            width='100%'
            direction='column'
            alignItems={{ sm: 'center' }}
            gap='20px'
          >
            <StyledButton variant='contained' size='medium' href='https://stokastic.com/pricing' sx={{ textTransform: 'uppercase' }}>
              Subscribe
            </StyledButton>
            {!isAuthenticated && (
              <StyledButton variant='contained' size='medium' onClick={() => login()}>
                Log in
              </StyledButton>
            )}
          </Stack>
        )}
      </Stack>
    </Container>
  )
}

export default Subscribe;
